import { redirect } from '@tanstack/react-router'

import { DASHBOARD_PATH } from '@/features/group/post-login-path'

import { isAuthenticated } from './store'

export function publicEntryPath() {
  return isAuthenticated() ? DASHBOARD_PATH : '/login'
}

export function redirectAuthenticated() {
  if (isAuthenticated()) throw redirect({ to: DASHBOARD_PATH, replace: true })
}

export function requireAuthentication() {
  if (!isAuthenticated()) throw redirect({ to: '/login', replace: true })
}
